import { getAuth } from 'firebase/auth';

export const isDemoUser = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('demo') === 'true';
};

export const getCurrentUser = () => {
  if (isDemoUser()) {
    return { uid: 'demo-user' };
  }
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    console.log('Current Auth User:', {
      uid: user?.uid,
      email: user?.email,
      isLoggedIn: !!user
    });
    return user;
  } catch (error) {
    console.log('Firebase not initialized, returning null');
    return null;
  }
};

export const isUserSubmission = (submission, currentUser) => {
  if (!currentUser || !submission) return false;
  return submission.userId === currentUser.uid || submission.email === currentUser.email;
};